(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CompanyReportAdminController', CompanyReportAdminController);

        CompanyReportAdminController.$inject = ['$scope','$sessionStorage','$filter', 'CompanyReportService', 'PortfolioTrackerService', '$window', '$state', '$uibModal', '$timeout'];

    function CompanyReportAdminController($scope,$sessionStorage,$filter, CompanyReportService, PortfolioTrackerService, $window, $state, $uibModal, $timeout) {
        var userGrid = ''
        var templateGrid = ''
        $scope.templateGrid = {
            //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
            dataProvider : [],
            delegate : $scope
        };
        var editableGrid = '';
        var vm = this;
        $scope.editSubsFlag = false;
        $scope.message = '';
        $scope.isEdit = false;
        $scope.clientNameList = [];
        $scope.excludeInternalclientNameList = [];
        $scope.clientModel = 'Select Client';
        $scope.assignClient = 'Select Client';
        $scope.assignAdmin = 'Select Admin';
        $scope.assignTemplate = 'Select Template';
        //$scope.subsLimit = 0;
		$scope.porttoDate = '';
		$scope.portfromDate = '';
		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.usageTrackerGrid = '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
        $scope.requiredFormat = $scope.formats[4];
        $scope.showGrid = false;
        $scope.setup = 'C';
        $scope.adminList = [];
        $scope.templateList = [];
        $scope.availableUsers = [ {
            "id" : null,
            "userName" : null,
            "clientName" : null,
            "clientId" : null,
            "fullName" : null
        }];
        $scope.selectedUsers = [];
        $scope.selection = false;
        $scope.restrictAcc = {
            "crisilAnalytics": {
                "parent": false,
                "irs": false,
                "companyScorecard": false,
                "fsm": false
            },
            "companyGroupOverview": {
                "parent": false,
                "mcaCharges": false
            },
            "companyFinancials": {
                "parent": false,
                "summary": false,
                "detailedAnnual": false,
                "detailedQuarterly": false
            },
            "ratings": {
                "parent": false,
                "outstandingRating": false,
                "instrumentRating": false,
                "ratingDrivers": false,
                "bankerDetails": false,
                "ratingHistory": false
            },
            "capitalMarketData": {
                "parent": false,
                "ytm": false,
                "debtIssuance": false,
                "cpIssuance": false,
                "keyStockIndicator": false,
                "bulkAndBlock": false
            },
            "crisilOutlook": {
                "parent": false,
                "industryOutlook": false,
                "economyOutlook": false
            },
            "peerBenchmarking": false,
            "alternateData": {
                "parent": false,
                "epfoContribution": false,
                "dueDiligence": false,
                "litigations": false,
                "gstCompliance": false
            }
        }
        $scope.onSetupChange = function() {
            if($scope.clientModel != 'Select Client') {
                if($scope.setup == 'R') {
                    $scope.getClientRestrictions();
                } else {
                    CompanyReportService.getClientUsers($scope.clientModel).then(function(response) {
                            $scope.subscriptionsObj = response;
                            $scope.userGrid = {
                                //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                                dataProvider : response.users ? response.users : [],
                                delegate : $scope
                            };
                            $scope.editableGrid = {
                                //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                                dataProvider : response.users ? response.users : [],
                                delegate : $scope
                            };
                            $scope.showGrid = true;
                            $scope.isEdit = false;
                        }, function(error) {}
                    );
                    $scope.getClientTemplates();
                }
            }
        }

        $scope.editTable = function() {
            $scope.isEdit = true;
        }

        $scope.editSubscriptionLimit = function() {
            $scope.isSubsEdit = true;
        }

        $scope.cancelEdit = function() {
            $scope.isEdit = false;
        }

        $scope.cancelSubsEdit = function() {
            $scope.isSubsEdit = false;
        }
        
        $scope.$watch('fromDate', function() {
			if (!$scope.fromDate) {
				return;
			}
			if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
				$scope.endMaxDate = new Date();
			} else {
				$scope.startMaxDate = $scope.fromDate;
			}
			$scope.fromDate = $scope.fromDate;

		});

		$scope.$watch('misReport.toDate', function() {
			if (!$scope.toDate) {
				return;
			}
			if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
				// $scope.endMaxDate = $scope.misReport.toDate;
			} else {
				$scope.startMaxDate = $scope.toDate;
			}
			$scope.toDate = $scope.toDate;
		});

		$scope.setTotalLimit = function() {
            var obj = {
                "id": vm.subsLimit,
                "name": $scope.clientModel
            }
            $scope.message = '';
            CompanyReportService.saveClientSubscriptionLimit(obj)
                .then(function(response) {
                    $scope.message = response.data;
                    $scope.isError = false;
                    $scope.getClientUsers();
                    $scope.cancelEdit();
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                }
            );
            
        }
		$scope.restFilter = function() {
			// var d = new Date(); 
			// d.setMonth(d.getMonth() - 6);
			// $scope.portfromDate = d;
			// $scope.porttoDate = new Date();
			// $scope.fromDate = d;
			// $scope.toDate = new Date();
            $scope.clientModel = 'Select Client';
            $scope.selectedclientNameTemp = [];
            $scope.setup = '';
		}
        //$scope.restFilter();
		// get Client name List for client name filter
		$scope.getClientNameList = function() {
			CompanyReportService.getClientNameList().then(function(data) {
				$scope.clientNameList = data;
				$scope.excludeInternalclientNameList=[];
				angular.forEach($scope.clientNameList,function(dto){
					//if(dto.labelName !='internalUser'){
				$scope.excludeInternalclientNameList.push(dto);
					//}
				});
			}, function(errordata) { });
			
			console.log($scope.excludeInternalclientNameList);
		}
		
		$scope.checkErrForSme = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();

			if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};
        
        $scope.userGridCompletion = function(event) {
            userGrid = event.target;
            userGrid.validateNow();
        }
        
        $scope.templateGridCompletion = function(event) {
            templateGrid = event.target;
            templateGrid.validateNow();
        }

        $scope.editableGridCompletion = function(event) {
            editableGrid = event.target;
            editableGrid.validateNow();
        }

        $scope.saveAndSetLimit = function() {
            var clientsArray = [];
           
            $scope.message = '';
            for (var index = 0; index <$scope.userGrid.dataProvider.length; index++) {
                var temp = document.getElementById('userType'+$scope.userGrid.dataProvider[index].id);
                
	            if(null != document.getElementById('userType'+$scope.userGrid.dataProvider[index].id)){
                var item = document.getElementById('userType'+$scope.userGrid.dataProvider[index].id).value;
                if(item) {
                    if(item != 'Select User Type') {
                        var newCompReq = document.getElementById('editCompReq'+$scope.userGrid.dataProvider[index].id).value || 0;
                       // var newSubsReq = document.getElementById('editSubsReq'+$scope.userGrid.dataProvider[index].id).value || 0;

                        if(($scope.userGrid.dataProvider[index].userType != item) || (newCompReq ? $scope.userGrid.dataProvider[index].newCompanyRequest != newCompReq : false)) {
                            clientsArray.push({
                                login: $scope.userGrid.dataProvider[index].userName,
                                userType: document.getElementById('userType'+$scope.userGrid.dataProvider[index].id).value,
                                isActive: 'Y',
                                clientId: $scope.userGrid.dataProvider[index].clientId,
                                 downloadLimit: $scope.userGrid.dataProvider[index].userLimit,
                                // downloadLimit: newSubsReq,
                                 newCompanyRequest: document.getElementById('editCompReq'+$scope.userGrid.dataProvider[index].id).value || 0
                                //newCompanyRequest: newCompReq
                                
                            });
                        }
                    }
                 }
                }
            }
            CompanyReportService.saveCompanyInfoAdmin(clientsArray)
                .then(function(response) {
                    $scope.message = response.data;
                    $scope.isError = false;
                    $scope.getClientUsers();
                    $scope.cancelEdit();
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                }
            );
            console.log(clientsArray);
        }

        $scope.saveAndSetLimitExt = function() {
            var clientsArray = [];
           
            $scope.message = '';
            for (var index = 0; index <$scope.userGrid.dataProvider.length; index++) {
                var temp = document.getElementById('userType'+$scope.userGrid.dataProvider[index].id);
                
	            if(null != document.getElementById('userType'+$scope.userGrid.dataProvider[index].id)){
                var item = document.getElementById('userType'+$scope.userGrid.dataProvider[index].id).value;
                if(item) {
                    if(item != 'Select User Type') {
                        var newCompReq = document.getElementById('editCompReq'+$scope.userGrid.dataProvider[index].id).value || 0;
                        var newSubsReq = document.getElementById('editSubsReq'+$scope.userGrid.dataProvider[index].id).value || 0;

                        if( ($scope.userGrid.dataProvider[index].userLimit != newSubsReq) || ($scope.userGrid.dataProvider[index].userType != item) || (newCompReq ? $scope.userGrid.dataProvider[index].newCompanyRequest != newCompReq : false)) {
                            clientsArray.push({
                                login: $scope.userGrid.dataProvider[index].userName,
                                userType: document.getElementById('userType'+$scope.userGrid.dataProvider[index].id).value,
                                isActive: 'Y',
                                clientId: $scope.userGrid.dataProvider[index].clientId,
                                // downloadLimit: $scope.userGrid.dataProvider[index].userLimit,
                                 downloadLimit: newSubsReq,
                                // newCompanyRequest: document.getElementById('editCompReq'+$scope.userGrid.dataProvider[index].id).value || 0
                                newCompanyRequest: newCompReq
                                
                            });
                        }
                    }
                 }
                }
            }
            CompanyReportService.saveCompanyInfoAdmin(clientsArray)
                .then(function(response) {
                    $scope.message = response.data;
                    $scope.isError = false;
                    $scope.getClientUsers();
                    $scope.cancelEdit();
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                }
            );
            console.log(clientsArray);
        }



        $scope.getClientUsers = function() {
            if($scope.clientModel == 'Internal User') {
                $scope.setup = 'T';
            }
            if($scope.clientModel == 'External User') {
                $scope.setup = 'E';
            }
            if($scope.setup == 'R') {
                $scope.getClientRestrictions();
            } else {
                CompanyReportService.getClientUsers($scope.clientModel).then(function(response) {
                        $scope.subscriptionsObj = response;
                        $scope.userGrid = {
                            //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                            dataProvider : response.users ? response.users : [],
                            delegate : $scope
                        };
                        $scope.editableGrid = {
                            //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                            dataProvider : response.users ? response.users : [],
                            delegate : $scope
                        };
                        $scope.showGrid = true;
                        $scope.isEdit = false;
                    }, function(error) {}
                );
                $scope.getClientTemplates();
                $sessionStorage.clientModel = $scope.clientModel;
            }
        }

        $scope.userTypeTemplate = function(rowData, column) {
            var html = '';
            if(rowData.userType) {
                rowData.userType == 'Client Admin' ? html =  '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option  disabled>Select User Type</option><option value="Client Admin" selected>Client Admin</option><option value="Client Associate">Client Associate</option></select></div>' : html =  '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate" selected>Client Associate</option></select></div>';
            } else {
                //html = '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option selected value = "Client Associate">Client Associate</option><option value="Client Admin">Client Admin</option></select></div>';
                html = '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option selected disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate">Client Associate</option></select></div>';
            }
            // if(rowData.userType) {
            //     rowData.userType == 'Client Admin' ? html =  '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option  disabled>Select User Type</option><option value="Client Admin" selected>Client Admin</option><option value="Client Associate">Client Associate</option></select><span class="load col-md-1" onClick= "saveUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-check hover upload-color" title="Save" ></i></span><span class="load col-md-1" onClick= "deleteUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-times hover upload-fail"></i></span></div>' : html =  '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate" selected>Client Associate</option></select><span class="load col-md-1" onClick= "saveUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-check hover upload-color" title="Save"></i></span><span class="load col-md-1" onClick= "deleteUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-times hover upload-fail"></i></span></div>';
            // } else {
            //     html = '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option selected disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate">Client Associate</option></select><span class="load col-md-1" onClick= "saveUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-check hover upload-color" title="Save" ></i></span><span class="load col-md-1" onClick= "deleteUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-times hover upload-fail" onClick= "deleteUserType(this)"></i></span></div>';
            // }
            return html;
        }

        $scope.userTypeTemplateExt = function(rowData, column) {
            var html = '';
            if(rowData.userType) {
                rowData.userType == 'Client Admin' ? html =  '<div class="row no-margins"><select disabled="true" id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option  disabled>Select User Type</option><option value="Client Admin" selected>Client Admin</option><option value="Client Associate">Client Associate</option></select></div>' : html =  '<div class="row no-margins"><select disabled="true" id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate" selected>Client Associate</option></select></div>';
            } else {
                //html = '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option selected value = "Client Associate">Client Associate</option><option value="Client Admin">Client Admin</option></select></div>';
                html = '<div class="row no-margins"><select disabled="true" id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option selected disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate">Client Associate</option></select></div>';
            }
            // if(rowData.userType) {
            //     rowData.userType == 'Client Admin' ? html =  '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option  disabled>Select User Type</option><option value="Client Admin" selected>Client Admin</option><option value="Client Associate">Client Associate</option></select><span class="load col-md-1" onClick= "saveUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-check hover upload-color" title="Save" ></i></span><span class="load col-md-1" onClick= "deleteUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-times hover upload-fail"></i></span></div>' : html =  '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate" selected>Client Associate</option></select><span class="load col-md-1" onClick= "saveUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-check hover upload-color" title="Save"></i></span><span class="load col-md-1" onClick= "deleteUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-times hover upload-fail"></i></span></div>';
            // } else {
            //     html = '<div class="row no-margins"><select id="userType'+rowData.id+'" name="userType'+rowData.id+'" class="auto-width col-md-6 form-control" required><option selected disabled>Select User Type</option><option value="Client Admin">Client Admin</option><option value="Client Associate">Client Associate</option></select><span class="load col-md-1" onClick= "saveUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-check hover upload-color" title="Save" ></i></span><span class="load col-md-1" onClick= "deleteUserType(this, userType'+rowData.id+'.value)"><i class="fa fa-times hover upload-fail" onClick= "deleteUserType(this)"></i></span></div>';
            // }
            return html;
        }

       

        $scope.userLimitTemplate = function(rowData, column) {
            var html = '';
            html= '<input class="form-control" id="editField'+rowData.id+'" type="number" value="'+ rowData.userLimit +'"readonly>'
            return html;
        }

        $scope.newCompanyRequestsTemplate = function(rowData, column) {
            var html = '';
            html= '<input oninput="formatCompanyReq(this)" step="1"  class="form-control" id="editCompReq'+rowData.id+'" type="number" value="'+ rowData.newCompanyRequest +'" readonly>'
            return html;
        }

        $scope.newSubscriptionLimitTemplate = function(rowData, column) {
            var html = '';
            html= '<input oninput="subsLimitFormatting(this)" step="1"  class="form-control" id="editSubsReq'+rowData.id+'" type="number" value="'+ rowData.userLimit +'">'
            return html;
        }

        $window.formatCompanyReq = function(input){
            if(input.value < 0) input.value=Math.abs(input.value);
            if(input.value.length > 2) input.value = input.value.slice(0, input.value.length);
        }

        $window.subsLimitFormatting = function(input){
            if(input.value < 0) input.value=Math.abs(input.value);
            if(input.value.length > 2) input.value = input.value.slice(0, input.value.length);
        }

        $window.saveUserType = function(row, userType) {
            $scope.message = '';
            var item = row.parentNode.parentNode.component.data;
            var compInfoAdmin = {
                login: item.userName,
                userType: userType,
                isActive: 'Y',
                clientId: item.clientId,
                limit: null,
                utilized: null
            }
            CompanyReportService.saveCompanyInfoAdmin(compInfoAdmin)
                .then(function(response) {
                    $scope.message = response.data;
                    $scope.isError = false;
                    $scope.getClientUsers();
                }, function(error) {
                    $scope.message = error.data;
                    $scope.isError = true;
                }
            );
        }

        $scope.closeAlert = function() {
            $scope.message = '';
        }

        $scope.getDate = function(rowData, column) {
            return $filter('date')(rowData.subscriptionExpiry,'dd-MMM-yyyy');
        }

        $window.deleteUserType = function(row, userType) {
            $scope.message = '';
            var item = row.parentNode.parentNode.component.data;
            var compInfoAdmin = {
                login: item.userName,
                userType: item.userType,
                isActive: 'Y',
                clientId: item.clientId
            }
            CompanyReportService.deleteCompanyInfoAdmin(compInfoAdmin)
                .then(function(response) {
                    $scope.getClientUsers();
                    $scope.message = response.data;
                    $scope.isError = false;
                }, function(error) {}
            );
            console.log(item);
        }

        $scope.getClientNameList();

        $scope.getClientTemplates = function() {
            CompanyReportService.getClientTemplates($scope.clientModel).then(function(response) {
                    $scope.templateGrid = {
                        //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                        dataProvider : response,
                        delegate : $scope
                    };
                }, function(error) {}
            );
        }

        $scope.getadminTemplatenamelist = function() {
        	$scope.clientModel = 'Select Client';
            $scope.assignClient = 'Select Client';
            $scope.assignAdmin = 'Select Admin';
            $scope.assignTemplate = 'Select Template';
            $scope.selectedUsers = [];
            $scope.availableUsers = [ {
                "id" : null,
                "userName" : null,
                "clientName" : null,
                "clientId" : null,
                "fullName" : null
            }];
            CompanyReportService.getadminTemplatenamelist().then(function(response) {
                $scope.adminList = response.adminNames;
                $scope.clientAdminList = response;
                $scope.getClientNameList();
                }, function(error) {}
            );
        }

        $scope.changeAdmin = function() {
            var parseddata = JSON.parse($scope.assignAdmin);
            $scope.templateList = $scope.clientAdminList.allAdminTemplates[parseddata.id];
        }

        $scope.changeClient = function() {
            CompanyReportService.assignTemplateUsers($scope.assignClient).then(function(response) {
                $scope.availableUsers = response;
            }, function(error) {}
        );
        }

        $scope.getSector = function(rowData, column) {
            return rowData.sector == 'G' ? 'Generic' : rowData.sector == 'M' ? 'Manufacturing' : 'Finance';
        }

        $scope.getCreatedDate = function(rowData, column) {
            return $filter('date')(rowData.cratedDate,'dd-MMM-yyyy');
        }

        $scope.getUpdatedDate = function(rowData, column) {
            return $filter('date')(rowData.cratedDate,'dd-MMM-yyyy');
        }


        $window.deleteCompany = function(item) {
            var itemObj = item.parentNode.component.data;
            $scope.selectedItemdata = item.parentNode.component.data;
            var modal = $uibModal.open({
                templateUrl : 'app/companyReport/customTemplate/delete-template.html',
                scope : $scope,
                backdrop : 'static'
            });
            $scope.modalInstancepeer = modal;
            $scope.clear = function() {
                $scope.modalInstancepeer.dismiss('cancel');
            }
    
            $scope.confirmDelete = function() {
                   
                CompanyReportService
                        .deleteTemplateByAdmin($scope.selectedItemdata)
                        .then(function(response) {
                            $scope.message = response.data;
                            $scope.isError = false;
                            $scope.modalInstancepeer.dismiss(true);
                            $scope.getClientTemplates();
                        }, function(error) {
                            $scope.modalInstancepeer.dismiss(true);
                            $scope.message = response.data;
                            $scope.isError = true;
                        });
                    console.log("selectedItemdata is" +  $scope.selectedItemdata);
                }
            }

        $window.editTemplate = function(item) {
            $scope.selectedItemdata = item.parentNode.component.data;
            $state.go('createnewtemplate', {
                templateJson: JSON.parse($scope.selectedItemdata.templateJson),
                createdOn : $scope.selectedItemdata.createdOn,
                isAdminEdit: 'Y'
            })
        }

        $window.viewTemplate = function(item) {
            $scope.selectedItemdata = item.parentNode.component.data;
            $state.go('createnewtemplate', {
                templateJson: JSON.parse($scope.selectedItemdata.templateJson),
                createdOn : $scope.selectedItemdata.createdOn,
                action: 'view'
            })

        }

        $scope.openCompany = function(rowData, column) {
            var data = '';
            if(rowData.clientName == 'Admin') {
                data = '<span class="View" onClick= "viewTemplate(this)"><i class="fa fa-eye hover font-size-14  padding-left-10 padding-right-10" title="View" ></i> </span><span class="load" onClick= "editTemplate(this)"><i class="fa fa-pencil-square-o hover upload-color font-size-14  padding-left-10 padding-right-10" title="Load" ></i> </span>     <span class="delete" onClick= "deleteCompany(this)"><i class="fa fa-trash-o  padding-left-10 padding-right-10 hover remove-color font-size-15" title="delete"></i> </span>';
            } else {
                data = '<span class="View" onClick= "viewTemplate(this)"><i class="fa fa-eye hover font-size-14  padding-left-10 padding-right-10" title="View" ></i> </span>';
            }
			return data;
        }

        $scope.assign = function() {
            var selectedUserList = [];
            for (var index = 0; index < $scope.selectedUsers.length; index++) {
                selectedUserList.push($scope.selectedUsers[index].userName)
            }
            var parseddata = JSON.parse($scope.assignAdmin);
            var assignObj = {
                "login" : parseddata.id,
                "templateName" : $scope.assignTemplate,
                "loginIds" : selectedUserList,
                "restrict" : false,
                "clientName" : $scope.assignClient
            }
            console.log(assignObj);
            CompanyReportService.assignTemplateToUsers(assignObj).then(function(response) {
                console.log(response);
                $scope.message = response;
                $scope.isError = false;
            }, function(error) {
                $scop.message = error;
                $scope.isError = true;
            });
        }
        
        $scope.myFilter = function(item){
        	if(item.labelName != 'internalUser'){
        		return item;
        	}
        }

        $scope.changePrimaryPoints = function(sectionNumber) {
            switch (sectionNumber) {
                case 1:
                    $scope.restrictAcc.companyGroupOverview.parent = $scope.restrictAcc.companyGroupOverview.mcaCharges;
                    break;
                case 2:
                    $scope.restrictAcc.companyFinancials.parent = $scope.restrictAcc.companyFinancials.summary || $scope.restrictAcc.companyFinancials.detailedAnnual || $scope.restrictAcc.companyFinancials.detailedQuarterly;
                    break;
                case 3:
                    $scope.restrictAcc.ratings.parent = $scope.restrictAcc.ratings.outstandingRating || $scope.restrictAcc.ratings.instrumentRating || $scope.restrictAcc.ratings.ratingDrivers || $scope.restrictAcc.ratings.bankerDetails || $scope.restrictAcc.ratings.ratingHistory;
                    break;
                case 4:
                    $scope.restrictAcc.capitalMarketData.parent = $scope.restrictAcc.capitalMarketData.keyStockIndicator || $scope.restrictAcc.capitalMarketData.debtIssuance || $scope.restrictAcc.capitalMarketData.cpIssuance || $scope.restrictAcc.capitalMarketData.bulkAndBlock || $scope.restrictAcc.capitalMarketData.ytm;
                    break;
                case 6:
                    $scope.restrictAcc.crisilAnalytics.parent = $scope.restrictAcc.crisilAnalytics.fsm || $scope.restrictAcc.crisilAnalytics.irs || $scope.restrictAcc.crisilAnalytics.companyScorecard;
                    break;
                case 7:
                    $scope.restrictAcc.crisilOutlook.parent = $scope.restrictAcc.crisilOutlook.industryOutlook || $scope.restrictAcc.crisilOutlook.economyOutlook;
                    break;
                case 8:
                    $scope.restrictAcc.alternateData.parent = $scope.restrictAcc.alternateData.epfoContribution || $scope.restrictAcc.alternateData.dueDiligence || $scope.restrictAcc.alternateData.litigations || $scope.restrictAcc.alternateData.gstCompliance;
                    break;
                default:
                    break;
            }
        }

        $scope.changeSecondaryPoints = function(sectionNumber) {
            switch (sectionNumber) {
                case 1:
                    $scope.restrictAcc.companyGroupOverview.mcaCharges = $scope.restrictAcc.companyGroupOverview.parent;
                    break;
                case 2:
                    $scope.restrictAcc.companyFinancials.summary = $scope.restrictAcc.companyFinancials.detailedAnnual = $scope.restrictAcc.companyFinancials.detailedQuarterly = $scope.restrictAcc.companyFinancials.parent;
                    break;
                case 3:
                    $scope.restrictAcc.ratings.outstandingRating = $scope.restrictAcc.ratings.instrumentRating = $scope.restrictAcc.ratings.ratingDrivers = $scope.restrictAcc.ratings.bankerDetails = $scope.restrictAcc.ratings.ratingHistory = $scope.restrictAcc.ratings.parent;
                    break;
                case 4:
                    $scope.restrictAcc.capitalMarketData.keyStockIndicator = $scope.restrictAcc.capitalMarketData.debtIssuance = $scope.restrictAcc.capitalMarketData.cpIssuance = $scope.restrictAcc.capitalMarketData.bulkAndBlock = $scope.restrictAcc.capitalMarketData.ytm = $scope.restrictAcc.capitalMarketData.parent;
                    break;
                case 6:
                    $scope.restrictAcc.crisilAnalytics.fsm = $scope.restrictAcc.crisilAnalytics.irs = $scope.restrictAcc.crisilAnalytics.companyScorecard = $scope.restrictAcc.crisilAnalytics.parent;
                    break;
                case 7:
                    $scope.restrictAcc.crisilOutlook.industryOutlook = $scope.restrictAcc.crisilOutlook.economyOutlook = $scope.restrictAcc.crisilOutlook.parent;
                    break;
                case 8:
                    $scope.restrictAcc.alternateData.epfoContribution = $scope.restrictAcc.alternateData.dueDiligence = $scope.restrictAcc.alternateData.litigations = $scope.restrictAcc.alternateData.gstCompliance = $scope.restrictAcc.alternateData.parent;
                    break;
                default:
                    break;
            }
        }

        $scope.changeAllPoints = function() {
            $scope.restrictAcc.companyGroupOverview.parent = $scope.restrictAcc.peerBenchmarking = $scope.restrictAcc.companyFinancials.parent = $scope.restrictAcc.ratings.parent = $scope.restrictAcc.capitalMarketData.parent = $scope.restrictAcc.crisilOutlook.parent = $scope.restrictAcc.crisilAnalytics.parent = $scope.restrictAcc.alternateData.parent = $scope.selection;
            $scope.changeSecondaryPoints(1);
            $scope.changeSecondaryPoints(2);
            $scope.changeSecondaryPoints(3);
            $scope.changeSecondaryPoints(4);
            $scope.changeSecondaryPoints(6);
            $scope.changeSecondaryPoints(7);
            $scope.changeSecondaryPoints(8);
        }

        $scope.setAccess = function() {
            var clientObj = _.find($scope.excludeInternalclientNameList, ['name', $scope.clientModel]);
            var accessObj = {
                clientId: clientObj.id,
                clientCode: clientObj.labelName,
                clientName: clientObj.name,
                companyReportRistrictDTO: $scope.restrictAcc
            }
            $scope.message = '';
            CompanyReportService.setRestrictiveAccess(accessObj).then(
				function(successData) {
					$scope.message = successData.data;
                    $scope.isError = false;
					$scope.responseMessage = successData.data;
				}, function (errorData) {
					$scope.message = errorData.data;
                    $scope.isError = false;
					$scope.responseMessage = errorData.data;
				 }
			);
        }

        $scope.getClientRestrictions = function() {
            if($scope.clientModel != 'Select Client') {
                var clientObj = _.find($scope.excludeInternalclientNameList, ['name', $scope.clientModel]);
                var accessObj = {
                    clientId: clientObj.id,
                    clientCode: clientObj.labelName,
                    clientName: clientObj.name
                }
                CompanyReportService.getClientRestrictions(accessObj).then(
                    function(successData) {
                        if(successData.data) {
                            $scope.restrictAcc = successData.data;
                        }
                        $scope.showGrid = true;
                    }, function (errorData) {
                     }
                );
            }
        }

        $scope.getBDName = function() {
            var obj = _.find($scope.excludeInternalclientNameList, ['name', $scope.clientModel]);
            return obj ? obj.clientBdName : '';
        }

        $scope.getBdHref = function() {
            var obj = _.find($scope.excludeInternalclientNameList, ['name', $scope.clientModel]);
            return obj ? 'mailto:' + obj.clientBdName : '';
        }
        
        $scope.ifInputsInvalid = function() {
            return $scope.clientModel == 'Select Client';
        }

        $scope.applyFiltersModal = function() {
			$uibModal.open({
				templateUrl: 'app/companyReport/customFilters/customfilter.html',
				size: 'md',
				scope: $scope,
				controller: 'ConfirmationModalController'
			})
		}

        $scope.getCompaniesForAlert = function() {
            CompanyReportService.getCompaniesForAlert().then(function(response) {
                $scope.filtercompanies = response;
			}, function(error) {});
        }

    }
})();